import { useRouter } from 'next/router'

import { useBucket } from '@mc/experiments-react'

import { CM_TIMELINE_VIEW_FLAG_NAME } from '../constants'

// Matches /classes/[slug] but not /classes/[slug]/chapters
const isClassPage = (pathname: string) => /^\/classes\/[^/]+$/.test(pathname)

export const useCMTimelineViewExp = () => {
  const router = useRouter()
  const bucket = useBucket(CM_TIMELINE_VIEW_FLAG_NAME)

  const isCmPage = isClassPage(router.pathname)

  return { isVariant1: bucket === 'variant_1' && isCmPage }
}
